export const enum ErrorMessageVariants {
    PAYMENT = `payment`,
    UTAP = `utap`,
}